const PROJECT_ID = "linear-poet-92723";

const LOCAL_FUNCTION_NAME_BY_REMOTE_NAME = {
  "get-sheet-values": "getSheetValues",
  "cors-proxy": "corsProxy",
  "make-sheet": "makeSheet",
  "append-sheet-values": "appendSheetValues",
  "update-sheet-values": "updateSheetValues",
  "batch-update-sheet": "batchUpdateSheet",
  "google-auth-session": "googleAuthSession",
  "refresh-google-access-token": "refreshGoogleAccessToken",
};

const normalizeBaseUrl = (value) => {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) {
    return null;
  }
  return trimmed.replace(/\/+$/, "");
};

const isLocalBrowserHost = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const hostname = String(window.location?.hostname ?? "").toLowerCase();
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "::1"
  );
};

const DEFAULT_FUNCTIONS_BASE_URL = isLocalBrowserHost()
  ? `http://localhost:8080/${PROJECT_ID}/us-central1`
  : `/api`;

const FUNCTIONS_BASE_URL =
  normalizeBaseUrl(process.env.REACT_APP_FUNCTIONS_BASE_URL) ||
  DEFAULT_FUNCTIONS_BASE_URL;

export const getFunctionUrl = (functionName) =>
  `${FUNCTIONS_BASE_URL}/${
    isLocalBrowserHost()
      ? (LOCAL_FUNCTION_NAME_BY_REMOTE_NAME[functionName] ?? functionName)
      : functionName
  }`;

export const getOptionalFunctionUrlOverride = (envValue, functionName) => {
  const normalizedOverride = normalizeBaseUrl(envValue);
  if (!normalizedOverride) {
    return getFunctionUrl(functionName);
  }

  const functionSegment = isLocalBrowserHost()
    ? (LOCAL_FUNCTION_NAME_BY_REMOTE_NAME[functionName] ?? functionName)
    : functionName;

  try {
    const parsed = new URL(normalizedOverride);
    const pathname = parsed.pathname.replace(/\/+$/, "");
    if (!pathname || pathname === "") {
      return `${normalizedOverride}/${functionSegment}`;
    }
    if (pathname === `/${functionSegment}` || pathname.endsWith(`/${functionSegment}`)) {
      return normalizedOverride;
    }
    return `${normalizedOverride}/${functionSegment}`;
  } catch (error) {
    return getFunctionUrl(functionName);
  }
};

export default getFunctionUrl;
